import React from 'react';

import ProviderFactory from '../common/components/provider';
import FFPage from '../common/containers/ff-page';

export default ProviderFactory(<FFPage />);
